import imgLoad from "@/components/imgLoad";
import DecryptImg from "@/components/decrypt-img/index.vue";
import Gallery from "@/components/Gallery/index.vue";
import imgsUpload from "@/components/imgsUpload";
import baseUpload from "@/components/baseUpload";
import baseUploadNew from "@/components/baseUploadNew";
// import globalUploader from '@/components/globalUploader

import cropper from "@/components/cropper";
export default (Vue) => {
  Vue.component("ImgLoad", imgLoad);
  Vue.component("DecryptImg", DecryptImg);
  Vue.component("gallery", Gallery);
  Vue.component("ImgsUpload", imgsUpload);
  Vue.component("BaseUpload", baseUpload);
  Vue.component("BaseUploadNew", baseUploadNew);
  Vue.component("Cropper", cropper);
  // Vue.component('GlobalUploader', globalUploader)
};
